import { useEffect } from "react";
import { useSelector } from "react-redux";
import RenderRoute from "./routes/RenderRoute";
import { useLocation } from "react-router-dom";

function App() {
  const { currentStore } = useSelector((state: any) => state.config);
  const app = useSelector((state: any) => state.app.data);
  const location = useLocation();

  useEffect(() => {
    if (!currentStore && app?._id && location.pathname !== "/app") {
      document.getElementById("display-store")?.click();
    }
  }, [currentStore, app, location.pathname]);

  return (
    <>
      <RenderRoute />
    </>
  );
}

export default App;
